import { useEffect } from 'react';

import * as Sentry from '@sentry/react';
import { useLocation } from 'react-router-dom';

export const useSentryRouteTagging = (
  getFeatureArea: (pathname: string) => string
) => {
  const location = useLocation();
  const featureArea = getFeatureArea(location.pathname);

  useEffect(() => {
    Sentry.getGlobalScope().setTags({
      featureArea,
    });
  }, [featureArea]);
};
